import React from 'react';
import { Button, Modal, Text } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { useNavigate } from 'react-router-dom';

interface Props {
  onClose(): void;
  opened: boolean;
}

const TRANSLATION_DOMAIN = 'account:update-security-details-modal';

export function UpdateSecurityDetailsModal({ opened, onClose }: Props): React.ReactElement {
  const { t } = useTranslationWithPrefix(TRANSLATION_DOMAIN);
  const navigate = useNavigate();

  const handleSubmit = () => {
    onClose();
    navigate('/profile/details?ref=enforce_mfa');
  };

  return (
    <Modal isOpen={opened} size="m" contentLabel={t('title')} onClose={onClose}>
      <Modal.Header title={t('title')} />
      <Modal.Body>
        <>
          <Text as="p">{t('description')}</Text>
          <ul>
            <Text as="li">{t('items.item-1')}</Text>
            <Text as="li">{t('items.item-2')}</Text>
          </ul>
        </>
      </Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button kind="primary" type="button" onClick={handleSubmit}>
          {t('update-security-details')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
